// Opt in at shared control groups; existing desktop classes remain authoritative.
export default function ResponsiveRow({ children, className = '', ...props }) {
    return <div className={`ia-responsive-row ${className}`} {...props}>{children}</div>;
}
